module.exports = __webpack_public_path__ + "img/csr_111123_H.69c26489.jpg";